<nz-modal
  [nzVisible]="true"
  [nzFooter]="null"
  [nzWidth]="684"
  [nzTitle]="header()"
  (nzOnCancel)="onClose()"
  [nzCloseIcon]="closeIcon"
  [nzContent]="modalContent"
  [nzMaskClosable]="false"
>
  <ng-template #closeIcon>
    <img alt="closeTab" src="assets/icons/exit_new.svg" />
  </ng-template>

  <ng-template #modalContent>
    @if (!showColorImplementationBanner()) {
      <div class="card-layer">
        @if (connectionErrorPopup() || connectionFullPopup()) {
          @for (item of instructions(); track item?.id ?? item) {
            <app-overlay-card-item
              [item]="item"
              class="connection-error-popup-item"
            ></app-overlay-card-item>
          }
        } @else {
          @for (item of instructions(); track item?.id ?? item) {
            <app-overlay-card-item
              [item]="item"
              [isInlet]="true"
            ></app-overlay-card-item>
          }
        }

        <div class="buttonwrapper">
          @if (connectionFullPopup()) {
            <app-nav-button
              [primary]="true"
              [svgIcon]="'icons:gateway'"
              (clickEvent)="connectToOtherGtway()"
            >
              {{
                header() === i18n.langString("gateway_inlet")
                  ? i18n.langString("connect_to_other_gateway")
                  : i18n.langString("connect_to_other_dau")
              }}
            </app-nav-button>
          } @else {
            <app-nav-button
              [primary]="true"
              [svgIcon]="'icons:fixed'"
              (clickEvent)="onClose()"
            >
              {{ i18n.langString("got_it") }}
            </app-nav-button>
          }
        </div>
      </div>
    } @else {
      <div class="flex-container htst_color_popup">
        <div>
          <span class="heading">
            {{ i18n.langString("choose_right_color_popup") }}
          </span>
        </div>

        <div class="inner-flex">
          <i nz-icon nzType="icons:info" class="status-icon svg-icon"></i>
          <span>{{ i18n.langString("choose_right_color_popup_2") }}</span>
        </div>

        <div class="flex-container width100">
          <div class="code-color-div-container">
            <div class="inlet-type">{{ i18n.langString("inlet") }}</div>
            <div class="color-box red">{{ i18n.langString("color_red") }}</div>
            <span> or </span>
            <div class="color-box green">
              {{ i18n.langString("color_green") }}
            </div>
          </div>

          <div class="code-color-div-container">
            <div class="inlet-type">{{ i18n.langString("outlet") }}</div>
            <div class="color-box black">
              {{ i18n.langString("color_black") }}
            </div>
            <span> or </span>
            <div class="color-box blue">
              {{ i18n.langString("color_blue") }}
            </div>
          </div>
        </div>
      </div>
    }
  </ng-template>
</nz-modal>
